import styled from "styled-components"

export const StyledWidget = styled.div`
  margin: 0 auto;
  width: 100%;

  & .kis-widget.vertical.responsive {
    display: flex;
    flex-direction: row;
  }

  & .kis_button {
    p {
      font-size: 12px;
      font-family: inherit !important;
    }
  }

  .kis-widget.responsive.horizontal .kis-widget__lead,
  .kis-widget.horizontal .kis-widget__lead {
    border: none;
  }

  .kis-widget.responsive.horizontal .kis-widget__cta-block,
  .kis-widget.horizontal .kis-widget__cta-block {
    border: none;
  }

  & .kis-widget.responsive.vertical .kis-widget__lead,
  .kis-widget.vertical,
  .kis-widget__lead {
    border: none;
  }

  & .kis-widget.responsive.horizontal,
  .kis-widget.responsive.vertical .kis-widget__cta-block,
  .kis-widget.vertical .kis-widget__cta-block {
    border: none;
  }

  & .kis-widget .kis-widget__lead .kis-widget__intro {
    color: #307e7e !important;
    font-size: 12px !important;
    font-family: inherit;
  }

  & .kis-widget .kis-widget__lead .kis-widget__course {
    font-size: 12px !important;
    line-height: 150%;
    color: #307e7e !important;
    font-family: inherit;
  }

  & .ofsKisClear .kis-widget__heading {
    font-family: inherit;
  }

  & .kis-widget .kis-widget__cta-block .kis-widget__heading span {
    font-size: 12px !important;
  }

  & .kis-widget .kis-widget__cta-block .kis-widget__heading strong {
    font-family: inherit;
    font-size: 12px !important;
  }
`
